/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "channelMappingArgDefs",
    graphQL: "ChannelMappingArgDef",
    name: "Channel Mapping Arg Definitions",
    defaultOrder: ['key'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: 'mappingArgs',
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Action Input Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channelMappingDef) => {
                return channelMappingDef['channelDef_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelMappingDef: {
            name: "Channel Mapping Definition",
            type: "relation",
            to: () => types['channelMappingDefs'],
            defaultValue: (channelMappingDef) => {
                return channelMappingDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ['channelDef'],
        },
        key: {
            name: "Key",
            type: "string",
            required: true,
            trim: true,
            validations: {
                matchRegexp: /^[a-zA-Z0-9_]+$/,
            },
            isPublic: true,
        },
        value: {
            name: "Value",
            type: "string",
            required: true,
            isPublic: true,
        },
        required: {
            name: "Required",
            type: "boolean",
            defaultValue: true,
            isPublic: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }

});
